import React from 'react';
import './SpeedSlider.css';

const SpeedSlider = ({ value, onChange, min, max, step, label }) => {
  return (
    <div className="speed-slider-container">
      <div className="slider-label">{label} : {Math.round(value * 100)}%</div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className="speed-slider"
      />
    </div>
  );
};

export default SpeedSlider;